import $ from 'jquery';

//@see one.app.community.dk.gwt.newtoolbar.client.ScrollHelper

function scrollToVisible(scrollElem, itemElem) {
    var $itemElem = $(itemElem);
    var $scrollElem = $(scrollElem);
    var scrollingElemTop = $scrollElem.offset().top;
    var scrolling = $scrollElem.scrollTop();
    var scrollingElemHeight = $scrollElem.height();
    var bottom = scrollingElemTop + scrollingElemHeight;

    var itemHeight = $itemElem.height();
    var itemTop = $itemElem.offset().top;

    if (itemTop + itemHeight > bottom) {
        $scrollElem.scrollTop(scrolling + itemTop + itemHeight - scrollingElemTop - scrollingElemHeight + 5);
    } else if (itemTop < scrollingElemTop) {
        $scrollElem.scrollTop(scrolling + itemTop - scrollingElemTop - 5);
    }
}

function scrollInLoadMoreDataPosition(scrollingElement) {
    var $scrollElem = $(scrollingElement);
    var deltaScrollToBottom = scrollingElement.scrollHeight - $scrollElem.scrollTop() - $scrollElem.height();
    return deltaScrollToBottom <= 200; // dialog.load.friends.start.bottom.height
}

function isScrollingVisible(scrollingElement) {
    var offsetHeight = scrollingElement.offsetHeight || 0;
    var scrollHeight = scrollingElement.scrollHeight || 0;
    return scrollHeight > offsetHeight;
}

function scrollIntoOKViewport(scrollToEl) {
    var top = scrollToEl.getBoundingClientRect().top + document.scrollingElement.scrollTop;
    var toolbar = document.getElementById('topPanel');
    if (toolbar) {
        top -= toolbar.offsetHeight;
    }
    document.scrollingElement.scrollTo(0, top);
}

export default { scrollToVisible, scrollInLoadMoreDataPosition, isScrollingVisible, scrollIntoOKViewport };

export { scrollToVisible, scrollInLoadMoreDataPosition, isScrollingVisible, scrollIntoOKViewport };
